module.exports = "https://www.gc-qa.gnp.com.mx/84d1a40d2f67494854e7702b6a5c666b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-g.svg
// module id = 1828
// module chunks = 0